import React from 'react';
import { compose, withProps, withState, withHandlers } from 'recompose';
import {
	withScriptjs,
	withGoogleMap,
	GoogleMap,
	Marker,
	Polyline,
	OverlayView
} from 'react-google-maps';
// import moment from "moment";

import CustomOverlayView from './CustomOverlayView';

import {
	latlng,
	colors,
	soloHoras,
	restanteHoras
	// masCercana
} from '../utils/helpers';

import styled, { keyframes } from 'styled-components';
import { mapStylesLight } from '../utils/mapStylesLight';
import { idaStyles, vueltaStyles } from '../utils/polyStyles';

const CustomOverlay = styled.div`
	font-family: ${colors.stack};
	font-size: 1.2em;
	background: ${colors.white};
	opacity: 1;
	border: 1px solid ${colors.grisclaro};
	text-align: center;
	width: 90px;
	cursor: pointer;
	font-weight: 700;
`;

const CustomOverlayParagraphs = styled.p`
	margin: 0;
	padding: 0.4em 0.4em 0em 0.4em;
`;

const Lugar = CustomOverlayParagraphs.extend`
	line-height: 1.2em;
	color: ${colors.ss};
`;

const Hora = CustomOverlayParagraphs.extend`
	color: ${colors.black};
	padding-bottom: 0.4em;
`;

const HoraLight = CustomOverlayParagraphs.extend`
	color: ${colors.black};
	padding-bottom: 0.4em;
	font-weight: 400;
`;

const pulse = keyframes`
  0% {
	 opacity: 0;
	 transform: scale(0.8);
  }
  5% {
	 opacity: 0.7;
	 transform: scale(0.8);
  }
  100% {
	  opacity: 0;
	  transform: scale(1.5);
  }
`;

const CustomOverlayActivo = CustomOverlay.extend`
	background: ${colors.black};
	border: none;
	&:before {
		content: '';
		display: block;
		width: 90px;
		height: 90px;
		top: -45px;
		right: 45px;
		background: ${colors.main};
		position: absolute;
		border-radius: 50%;
		z-index: -1;

		animation: ${pulse} 2s ease-out infinite;
	}
`;

const LugarActivo = Lugar.extend`
	color: ${colors.white};
	font-size: 1.2em;
`;

const HoraActivo = Hora.extend`
	color: ${colors.white};
	padding-bottom: 0.4em;
`;

const HoraLightActivo = HoraLight.extend`
	color: ${colors.white};
	padding-bottom: 0.4em;
	font-weight: 400;
`;

let iconSize = 20;

let icon = {
	path: 'M-10,0a10,10 0 1,0 20,0a10,10 0 1,0 -20,0',
	fillColor: colors.ss,
	fillOpacity: 1,
	strokeColor: 'transparent'
};

let iconGrande = {
	path: `M-${iconSize},0a${iconSize},${iconSize} 0 1,0 ${iconSize *
		2},0a${iconSize},${iconSize} 0 1,0 -${iconSize * 2},0`,
	fillColor: colors.main,
	fillOpacity: 0.5,
	strokeColor: 'transparent'
};

const getPixelPositionOffset = (width, height) => ({
	x: -(width / 2),
	y: -(height / 2)
});

const MyMapComponent = compose(
	withProps({
		googleMapURL:
			'https://maps.googleapis.com/maps/api/js?key=AIzaSyDAHjhJowqymGhcUO1Xlo1U5ilc0GjvZx0&v=3.exp&libraries=geometry,drawing,places',
		loadingElement: <div style={{ height: `100%` }} />,
		containerElement: <div style={{ height: `600px` }} />,
		mapElement: <div style={{ height: `100%` }} />
	}),
	withState('zoom', 'onZoomChange', 17),
	withHandlers(() => {
		const refs = {
			map: undefined
		};

		return {
			onMapMounted: () => ref => {
				refs.map = ref;
			},
			onZoomChanged: ({ onZoomChange }) => () => {
				onZoomChange(refs.map.getZoom());
			}
		};
	}),
	withScriptjs,
	withGoogleMap
)(props => (
	<GoogleMap
		defaultOptions={{ styles: mapStylesLight }}
		defaultZoom={props.zoom}
		zoom={props.zoom}
		ref={props.onMapMounted}
		defaultCenter={latlng(props.center)}
		// center={latlng(props.center)}
		onZoomChanged={props.onZoomChanged}
		dia={props.dia}
		dia_act={props.dia_act}
	>
		{props.markers.map((x, i) => {
			if (props.dia === props.dia_act && props.proximo === i) {
				return (
					<Marker
						className="iconGrande"
						icon={iconGrande}
						key={x.name}
						position={latlng(x.latlng)}
						title={x.name}
						onClick={props.onMarkerClick}
					/>
				);
			} else {
				return (
					<Marker
						icon={icon}
						key={x.name}
						position={latlng(x.latlng)}
						title={x.name}
						onClick={props.onMarkerClick}
					/>
				);
			}
		})}
		<Polyline options={idaStyles} path={props.pathIda} />
		<Polyline options={vueltaStyles} path={props.pathVuelta} />
		{props.zoom >= 17
			? props.markers.map((x, i) => {
					if (props.dia === props.dia_act && props.proximo === i) {
						return (
							<CustomOverlayView
								key={x.latlng}
								position={latlng(x.latlng)}
								mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
								getPixelPositionOffset={getPixelPositionOffset}
							>
								{props.dia === props.dia_act && (
									<CustomOverlayActivo onClick={props.onMarkerClick}>
										<LugarActivo>{`${x.name}`}</LugarActivo>
										{props.cambioHora ? (
											<HoraActivo>{`${soloHoras(x.hora)}`}</HoraActivo>
										) : (
											<HoraLightActivo>{`${restanteHoras(
												x.hora
											)}`}</HoraLightActivo>
										)}
									</CustomOverlayActivo>
								)}
							</CustomOverlayView>
						);
					} else {
						return (
							<CustomOverlayView
								key={x.latlng}
								position={latlng(x.latlng)}
								mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
							>
								<CustomOverlay onClick={props.onMarkerClick}>
									<Lugar>{`${x.name}`}</Lugar>
									{props.cambioHora ? (
										<Hora>{`${restanteHoras(x.hora)}`}</Hora>
									) : (
										<HoraLight>{`${soloHoras(x.hora)}`}</HoraLight>
									)}
								</CustomOverlay>
							</CustomOverlayView>
						);
					}
			  })
			: ''}
	</GoogleMap>
));

class mapaProcesiones extends React.PureComponent {
	state = {
		cambioHora: true,
		zoom: 1
	};

	componentDidMount() {
		this.delayedShowMarker();
	}

	delayedShowMarker = () => {
		setTimeout(() => {
			this.setState({ cambioHora: true });
		}, 7000);
	};

	handleMarkerClick = () => {
		this.setState({
			cambioHora: !this.state.cambioHora
		});
		this.delayedShowMarker();
	};

	render() {
		return (
			<MyMapComponent
				cambioHora={this.state.cambioHora}
				markers={this.props.markers}
				onMarkerClick={this.handleMarkerClick}
				pathIda={this.props.pathIda}
				pathVuelta={this.props.pathVuelta}
				center={this.props.center}
				zoom={this.props.zoom}
				pro_obj={this.props.pro_obj}
				proximo={this.props.proximo}
				dia={this.props.dia}
				dia_act={this.props.dia_act}
			/>
		);
	}
}

export default mapaProcesiones;



// WEBPACK FOOTER //
// ./src/components/ReactGoogleMaps.js